export default {
    baseComponents: {
        basePagination: {
            previous: 'Previous',
            next: 'Next',
            metaInfo: `
      Showing <span class="font-medium">{itemsFrom}</span>
      to <span class="font-medium">{itemsTo}</span>
      of <span class="font-medium">{itemsTotal}</span>
      results`,
            pageSize: 'Results per page',
        },
        baseDrawer: {
            maximize: 'Maximize',
            minimize: 'Minimize',
        },
    },
    general: {
        period: 'Period',
        from: 'From',
        to: 'To',
        contractStart: 'Contract start',
        day: 'Day | Days',
        today: 'Today',
        week: '{count} week | {count} weeks',
        hour: '{count} hour | {count} hours',
        days: '{count} day | {count} days',
        month: '{count} month | {count} months',
        custom: 'Custom',
        noData: 'No data available yet',
        isSelfManaged: 'Self-managed',
        general: 'General',
        services: 'Services',
        base: 'Base',
        kilowattHour: 'Kilowatt hour | Kilowatt hours',
        all: 'All',
        watts: 'W',
        noResultsFound: 'No results found',
        noResultsFoundDescription: 'Clear your filters and try again.',
        inclusive: 'inclusive',
        cpu: 'CPU | CPUs',
        diffInSeconds: '{count} second ago | {count} seconds ago',
        diffInMinutes: '{count} minute ago | {count} minutes ago',
        diffInHours: '{count} hour ago | {count} hours ago',
        diffInDays: '{count} day ago | {count} days ago',
        diffInWeeks: '{count} week ago | {count} weeks ago',
        diffInMonths: '{count} month ago | {count} months ago',
        timezones: {
            cet: 'CET',
            cest: 'CEST',
            currentGerman: '({timeZone} [{utcDifference}])',
        },
        mbps: 'Mbps',
        updatingData: 'Data is being loaded',
        termsAndPrivacy:
            'Our <a class="text-blue-700 hover:text-blue-600 cursor-pointer underline" href="{termsUrl}" target="_blank">Terms and Conditions</a> apply. Please note our <a class="text-blue-700 hover:text-blue-600 cursor-pointer underline" href="{privacyUrl}" target="_blank">Privacy Policy</a>.',
        startAt: 'Starts at {date}',
        endAt: 'Ends at {date}',
        phone: 'Phone',
        mail: 'Mail',
        new: 'New',
        status: 'Status',
    },
    actions: {
        addEntry: 'Add entry',
        addFile: 'Add file',
        add: 'Add',
        create: 'Create',
        show: 'Show',
        showAll: 'Show all',
        destroy: 'Delete',
        delete: 'Delete',
        copy: 'Copy',
        edit: 'Edit',
        download: 'Download',
        confirm: 'Confirm',
        cancel: 'Cancel',
        canceling: 'Canceling...',
        save: 'Save',
        back: 'Back',
        next: 'Next',
        complete: 'Complete',
        adjust: 'Adjust',
        logout: 'Sign out',
        backToLogin: 'Back to login',
        createResource: 'Create {resource}',
        editResource: 'Edit {resource}',
        feedback: 'Feedback',
        support: 'Support',
        deactivate: 'Deactivate',
        activate: 'Activate',
        moreInfo: 'More info',
        clearFilters: 'Clear filters',
        comment: 'Comment',
        contactSupport: 'Contact support',
        pay: 'Pay',
        payNow: 'Pay now',
        remove: 'Remove',
        editPassword: 'Edit password',
        turnOn: 'Turn on',
        turnOff: 'Turn off',
        goToTicket: 'Go to ticket',
        csvExport: 'Export CSV',
    },
    common: {
        loading: 'Loading...',
        pay: 'Pay',
        close: 'Close',
        retry: 'Retry',
        cancel: 'Cancel',
    },
    payment: {
        intentCreated: 'Payment intent created successfully',
        intentCreationFailed: 'Failed to create payment intent',
        paymentSuccessful: 'Payment completed successfully',
        paymentFailed: 'Payment failed',
        paymentCancelled: 'Payment cancelled',
        processingPayment: 'Processing payment...',
        payInvoice: 'Pay Invoice',
        invoiceNumber: 'Invoice Number',
        billingInformation: 'Billing Information',
        paymentMethod: 'Payment Method',
        fullName: 'Full Name',
        fullNamePlaceholder: 'Enter your full name',
        email: 'Mail',
        emailPlaceholder: 'Enter your mail address',
        payNow: 'Pay Now',
        paymentSuccessfulMessage: 'Your payment has been processed successfully.',
        initializing: 'Initializing payment form...',
        initializingPaymentForm: 'Initializing payment form...',
        stripeInitializationFailed: 'Failed to initialize payment form',
    },
    dialogs: {
        maintenance: {
            title: 'Maintenance work is currently taking place',
            message:
                'Your action could not be performed. Please excuse the inconvenience. The page will be reloaded automatically when the maintenance is completed.',
            countdown: 'Next try in {counter} seconds',
        },
        sessionExpiration: {
            title: 'Your session has expired',
            message: 'Please log in again.',
        },
        confirmation: {
            title: 'Are you sure?',
            message: 'Do you really want to continue?',
            destroyEntryMessage: 'Do you really want to delete this entry?',
        },
        feedback: {
            title: 'How can we improve our service?',
        },
        confirmPassword: {
            title: 'Confirm your password',
            toast: 'Password successfully confirmed',
        },
        doNotShowAgain: 'Do not show this message again',
    },
    globalMessages: {
        serverError: {
            message: 'Something went wrong!',
            description: 'Please try again later or contact our support.',
        },
        configuratorMaintenance: {
            message: 'Maintenance work',
            description:
                'Maintenance work is currently being carried out on the configurator. It will be available again shortly.',
        },
        insufficientPermissions: {
            message: 'Insufficient permissions',
            description:
                'You have been redirected to the dashboard because you do not have the required permissions.',
        },
        ticketNotFound: {
            message: 'Ticket not found.',
            description:
                'The ticket may have been deleted or you do not have access. You have been redirected to the ticket list.',
        },
        unconfirmedPassword: {
            message: 'Password was not confirmed!',
        },
        notFound: {
            message: 'Page or resource not found!',
            description:
                'Perhaps the address was entered incorrectly, the page was moved or is no longer available.<br /> If you have any questions, please <a href="#" class="underline cursor-pointer">contact our support</a>.',
        },
        maintenance: {
            message: 'Maintenance work is currently taking place',
            description:
                'This page will be available again shortly. Please try again later or <a href="#" class="underline cursor-pointer">contact our support</a>.',
        },
    },
    validations: {
        required: 'This is a mandatory field',
        requiredIf: 'This is a mandatory field',
        minLength: 'At least {min} characters',
        email: 'The entered mail address is invalid',
        ipV4: 'The entered IPv4 address is invalid',
        between: 'Please enter a value between {min} and {max}',
        sameAs: 'Must match "{otherName}"',
        fileSize50: 'The file must not be larger than 50 MB',
        allowedAttachmentType:
            'At least one attachment has an invalid file type. Allowed formats: PDF, JPG, PNG, GIF, WebP, TXT, CSV, DOC, DOCX, XLS, XLSX.',
        mustBeConfirmed: 'This field must be confirmed',
        endTimeTooEarly:
            'Please check your time entries. Currently, the end of your visit is before the specified arrival time.',
        endDateInPast:
            'Please check your date entries. The selected end date is in the past. Please choose a date in the future.',
        visitTooShort:
            'Please check your time entries. You should plan at least one hour for a visit to our datacenter.',
        startTimeInPast:
            'The selected start time is in the past. Please choose a time from {minTime} onwards.',
    },
    links: {
        privacy: 'Privacy',
        imprint: 'Imprint',
        dedicatedServer: 'Dedicated  Server',
        colocation: 'Colocation',
        cloudServer: 'Cloud Server',
        s3Storage: 'S3-Storage',
    },
};
